import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus, Copy } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable, Card, Input } from "../../components/admin/Fields";

const AdminMediaPage = () => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ filename: "", url: "", folder: "general", alt: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/media").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { ...form, filename: form.filename || form.url.split("/").pop() };
      await api.post("/admin/media", payload);
      setForm({ filename: "", url: "", folder: "general", alt: "" });
      load();
      toast.success("Eklendi");
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };
  const remove = async (r) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/media/${r.id}`); load();
  };
  const copy = (u) => { navigator.clipboard.writeText(u); toast.success("Kopyalandı"); };

  return (
    <div data-testid="admin-media-page">
      <AdminHeader eyebrow="Media" title="Medya Kütüphanesi" />
      <Card title="Yeni Görsel/URL Ekle">
        <form onSubmit={add} className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
          <Input label="URL" value={form.url} onChange={(v) => setForm({ ...form, url: v })} testId="media-url" />
          <Input label="Dosya adı" value={form.filename} onChange={(v) => setForm({ ...form, filename: v })} />
          <Input label="Klasör" value={form.folder} onChange={(v) => setForm({ ...form, folder: v })} />
          <Input label="Alt metin" value={form.alt} onChange={(v) => setForm({ ...form, alt: v })} />
          <Btn type="submit" disabled={busy || !form.url} testId="media-add"><Plus size={14} /> Ekle</Btn>
        </form>
      </Card>
      <div className="mt-8">
        <DataTable
          columns={[
            { key: "preview", label: "", render: (r) => <img src={r.url} alt="" className="w-14 h-14 object-cover border border-black/10" /> },
            { key: "filename", label: "Ad" },
            { key: "folder", label: "Klasör" },
            { key: "url", label: "URL", render: (r) => <span className="text-brand-medium text-xs truncate max-w-xs inline-block">{r.url}</span> },
            { key: "actions", label: "", render: (r) => (
              <div className="flex justify-end gap-2">
                <Btn variant="ghost" onClick={() => copy(r.url)}><Copy size={12} /></Btn>
                <Btn variant="danger" onClick={() => remove(r)}><Trash2 size={12} /></Btn>
              </div>
            ) },
          ]}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default AdminMediaPage;
